import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * CustomerCategoriesApi - axios parameter creator
 * @export
 */
const CustomerCategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/CustomerCategories/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/CustomerCategories/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, options = {}) => {
            const localVarPath = `/v1/CustomerCategories/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotionPolicies: async (id, options = {}) => {
            const localVarPath = `/v1/CustomerCategories/GetPromotionPolicies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CustomerCategoryToken} [CustomerCategoryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (CustomerCategoryToken, options = {}) => {
            const localVarPath = `/v1/CustomerCategories/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerCategoryToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (term, top, options = {}) => {
            const localVarPath = `/v1/CustomerCategories/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/CustomerCategories/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CustomerCategoryToken} [CustomerCategoryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (CustomerCategoryToken, options = {}) => {
            const localVarPath = `/v1/CustomerCategories/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerCategoryToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CustomerCategoriesApi - functional programming interface
 * @export
 */
const CustomerCategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomerCategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerCategoriesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerCategoriesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerCategoriesApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromotionPolicies(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromotionPolicies(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerCategoriesApi.getPromotionPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CustomerCategoryToken} [CustomerCategoryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(CustomerCategoryToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(CustomerCategoryToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerCategoriesApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(term, top, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(term, top, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerCategoriesApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerCategoriesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CustomerCategoryToken} [CustomerCategoryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(CustomerCategoryToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(CustomerCategoryToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerCategoriesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CustomerCategoriesApi - factory interface
 * @export
 */
const CustomerCategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomerCategoriesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, options) {
            return localVarFp.getByIds(request_body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotionPolicies(id, options) {
            return localVarFp.getPromotionPolicies(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CustomerCategoryToken} [CustomerCategoryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(CustomerCategoryToken, options) {
            return localVarFp.insert(CustomerCategoryToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(term, top, options) {
            return localVarFp.lookup(term, top, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {CustomerCategoryToken} [CustomerCategoryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(CustomerCategoryToken, options) {
            return localVarFp.update(CustomerCategoryToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomerCategoriesApi - object-oriented interface
 * @export
 * @class CustomerCategoriesApi
 * @extends {BaseAPI}
 */
class CustomerCategoriesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCategoriesApi
     */
    getAll(options) {
        return CustomerCategoriesApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCategoriesApi
     */
    getById(id, options) {
        return CustomerCategoriesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {Array<number>} [request_body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCategoriesApi
     */
    getByIds(request_body, options) {
        return CustomerCategoriesApiFp(this.configuration).getByIds(request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCategoriesApi
     */
    getPromotionPolicies(id, options) {
        return CustomerCategoriesApiFp(this.configuration).getPromotionPolicies(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {CustomerCategoryToken} [CustomerCategoryToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCategoriesApi
     */
    insert(CustomerCategoryToken, options) {
        return CustomerCategoriesApiFp(this.configuration).insert(CustomerCategoryToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {string} [term]
     * @param {number} [top]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCategoriesApi
     */
    lookup(term, top, options) {
        return CustomerCategoriesApiFp(this.configuration).lookup(term, top, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCategoriesApi
     */
    remove(id, options) {
        return CustomerCategoriesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {CustomerCategoryToken} [CustomerCategoryToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCategoriesApi
     */
    update(CustomerCategoryToken, options) {
        return CustomerCategoriesApiFp(this.configuration).update(CustomerCategoryToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { CustomerCategoriesApi, CustomerCategoriesApiAxiosParamCreator, CustomerCategoriesApiFactory, CustomerCategoriesApiFp };
//# sourceMappingURL=customer-categories-api.js.map
